import React, { Fragment, useState, useEffect } from "react";
import "./ReferAndEarn.scss";
import HeaderComponent from "../structure_components/desktop_screens/header_component/header_component";
import ReferFrndBanner from "./referFrndBanner/ReferFrndBanner";
import images from "../../../utilities/images/images";
import { Link } from "react-router-dom";
import HowItWorks from "./howItWorks/HowItWorks";
import Faqs from "./faqs/Faqs";
import CopyCode from "./copyCode/CopyCode";
import exclamationIcon from "../../../utilities/images/refer&earn/exclamationIcon.png";
import backBtn from "../../../utilities/images/refer&earn/BackBtn.png";
import { url_184 } from "../../../custom_utilities/api_services";

import CourseEnrollmentTermsAndConditions from "./courseEnrollmentTermsAndConditions/CourseEnrollmentTermsAndConditions";
import ReferalList from "./referalList/ReferalList";
import axios from "axios";
import { connect } from "react-redux";
import Footer_component from "../structure_components/desktop_screens/footer_component/Footer_component";
import Header_component from "../structure_components/desktop_screens/header_component/header_component";
import Mobile__right_sideBar_component from "../structure_components/mobile_screens/mobile_right_sideBar_component/mobile__right_sideBar_component";
import Mobile_header_component from "../structure_components/mobile_screens/mobile_header_component/mobile_header_component";
import MobileLeftSideBarComponent from "../structure_components/mobile_screens/mobile_left_sideBar_component/mobile_left_sideBar_component";

const ReferAndEarn = ({ token, tokenType, userData, userPreference, history }) => {
  const [showTerms, setShowTerms] = useState(false);
  const [data, setData] = useState({});

  const handleTermsClick = () => {
    setShowTerms(true);
  };

  const handleOpenReferandEarn = () => {
    setShowTerms(false);
  };

  const getReferalCode = async () => {
    const headers = {
      Authorization: `${tokenType} ${token}`,
    };
    try {
      const response = await axios.get(url_184, headers);

      if (response.status === 200) {
        console.log("getReferalCode", response.data);
        setData(response.data.data);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getReferalCode();

    // Scroll to the top of the page after a short delay
    const scrollToTop = () => {
      setTimeout(() => {
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
      }, 0);
    };

    // Scroll to the top when the component mounts
    scrollToTop();

    // Restore original scroll behavior when the component unmounts
    return () => {
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    };
  }, []);

  const [windowWidth, setWindowWidth] = useState(window.innerWidth)
  const setWidth = () => {
    setWindowWidth(window.innerWidth)
  }
  useEffect(() => {
    window.addEventListener( 'resize',setWidth)

    return (() => {
      window.removeEventListener('resize',setWidth)
    })
  },[windowWidth])

  return (
    <Fragment>
      {windowWidth <= 480 ? (
        /////for Mobile Screens////////////////////
        <Fragment>
          <MobileLeftSideBarComponent />
          <Mobile_header_component
            userPreference={userPreference}
            userData={userData}
          />
          <Mobile__right_sideBar_component history={history} />
        </Fragment>
      ) : (
        /////for Screens greater than Mobile Screens////////////////////
        <Fragment>
          <Header_component history={history} />
        </Fragment>
      )}
      <div className="ReferandEarn_wrapper">
        {!showTerms && (
          <div className="ReferandEarn_inner_wrapper">
            <div className="container">
              <div className="backBtnContent">
                <Link
                  className="backBtn"
                  to={{
                    pathname: "/user_dashboard",
                  }}
                >
                  <img src={backBtn} alt="backBtn" />
                </Link>
                <strong>Refer & Earn</strong>
              </div>
              <div className="referandEarn_Content">
                <div className="contentLeft">
                  <section>
                    <ReferFrndBanner data={data} />
                  </section>
                  <section>
                    <HowItWorks works={data.works} />
                  </section>
                  {windowWidth > 578 && (
                    <section>
                      <Faqs />
                    </section>
                  )}
                </div>
                <div className="contentRight">
                  <div className="sectionTitle">
                    Copy the code below and share it out!
                  </div>
                  <CopyCode data={data} />

                  <div className="termsAndconditions">
                    <img src={exclamationIcon} alt="exclamationIcon" />
                    <div className="text">
                      View
                      <span onClick={handleTermsClick}>Terms & Conditions</span>
                    </div>
                  </div>
                  <ReferalList token={token} tokenType={tokenType} />
                  {windowWidth <= 578 && (
                    <section>
                      <Faqs />
                    </section>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}

        {showTerms && (
          <div className="CourseEnrollmentTermsAndConditions">
            <CourseEnrollmentTermsAndConditions
              handleOpenReferandEarn={handleOpenReferandEarn}
            />
          </div>
        )}
      </div>
      <Footer_component />
      {/* {loader && <LoaderPopUp />} */}
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    token: state.auth.authToken,
    tokenType: state.auth.authType,
    userData: state.auth.user,
    userPreference: state.userPreference,
  };
};

export default connect(mapStateToProps, null)(ReferAndEarn);
